<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
  <router-view />

  <v-snackbar
    v-model="store.state.snackbar.show"
    :timeout="store.state.snackbar.timeout"
    :color="store.state.snackbar.color"
  >
    {{ store.state.snackbar.message }}
  
    <template #actions>
      <v-btn
        color="blue"
        variant="text"
        @click="store.state.snackbar.show = false"
      >
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup>
import { useStore } from 'vuex';
const store = useStore(); 


</script>

<style>
body{margin:0px;font-family: 'Mulish', sans-serif;}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50; */
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.bg-danger{background-color: #FF0000!important;}
.v-snackbar__actions > .v-btn > .v-btn__content{color: white;}
.v-list-item--one-line:nth-child(6){display: none!important;}
</style>
